// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1qi1-","footer":"ModalFilter_footer__3hcbK"};